import React, { useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import shuffle from "lodash/shuffle";
import debounce from "lodash/debounce";
import update from "immutability-helper";
import { DndProvider } from "react-dnd";
import MultiBackend from "react-dnd-multi-backend";
import SortItem from "../SortItem";
import { MatrixSortItem } from "../MatrixSortItem";
import { DropArea } from "../DropArea";
import { RandomMatrixSortItem } from "../RandomMatrixSortItem";
import HTML5toTouch from "react-dnd-multi-backend/dist/esm/HTML5toTouch";
// import { symbolTable } from "../../utils/constants";

const AnswerType = (props: any) => {
  const {
    type,
    answerData,
    handleAnswerChange,
    answer,
    preview,
    isRandom,
    attemptsDis,
    sortAnswers,
    setSortAnswers,
    setMatrixSortAnswers,
    matrixSortAnswers,
    randomMatrixAnswers,
    setRandomMatrixAnswers,
    qId,
  } = props;

  const [initialized, setInitialized] = React.useState(false);
  const handleClonzeAnswer = (e: any) => {
    if (e.target.name === "cloze_answer[]") {
      let answers: any = [];
      let fills = Array.from(document.getElementsByName("cloze_answer[]"));
      fills.map((f: any, i: number) => (answers[i] = f.value));
      if (e.keyCode === 13) {
        props.checkAnswer(answers);
      } else {
        handleAnswerChange(answers);
      }
    } else if (e.target.name === "other_answer[]") {
      if (e.keyCode === 13) {
        props.checkAnswer(e.target.value);
      }
    }
  };
  const compareValues = (val1: string, val2: string) => {
    if (val1.trim() === val2.trim()) {
      return true;
    }
    return false;
  };
  const handleMultipleAnswer = (e: any) => {
    let answers = [...answer];
    if (e.target.checked) {
      answers.push(e.target.value.trim());
    } else {
      for (let i = 0; i < answers.length; i++) {
        if (String(answers[i].trim()) === String(e.target.value.trim())) {
          answers.splice(i, 1);
        }
      }
    }
    handleAnswerChange(
      answers.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) === index;
      })
    );
  };
  const handleKeyDown = (e: any) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      let answers: any = [];
      let fills = Array.from(document.getElementsByName("cloze_answer[]"));
      fills.map((f: any, i: number) => (answers[i] = f.value));
    }
  };

  const moveColumnToDebounce = (dragIndex, hoverIndex) => {
    const dragCard = sortAnswers[dragIndex];
    setSortAnswers(
      update(sortAnswers, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragCard],
        ],
      })
    );
  };

  const moveCard = React.useCallback(debounce(moveColumnToDebounce, 10), [
    sortAnswers,
  ]);

  useEffect(() => {
    window.addEventListener("keyup", handleClonzeAnswer);
    if (type === "cloze_answer" && answer.length > 0) {
      let inputs = document.getElementsByClassName("qc-" + qId);
      answer.map(
        (val: any, i: number) => ((inputs[i] as HTMLInputElement).value = val)
      );
    }
    if (type === "cloze_answer") {
      if (!initialized) {
        let elements = document.getElementsByName("cloze_answer[]");
        if (elements[0]) {
          elements[0].focus();
        }
        if (elements[elements.length - 1]) {
          elements[elements.length - 1].addEventListener("keyup", (e) => {
            handleKeyDown(e);
          });
        }
        setInitialized(true);
      }
    } else if (type !== "single" && type !== "multiple") {
      if (!initialized) {
        if (document.getElementById("input-text-free-type-" + qId)) {
          (
            document.getElementById(
              "input-text-free-type-" + qId
            ) as HTMLInputElement
          ).focus();

          setInitialized(true);
        }
      }
    }
    return () => {
      window.removeEventListener("keyup", handleClonzeAnswer);
    };
  }, [handleClonzeAnswer]);

  const handleRandomDrop = React.useCallback(
    (index: number, item: any, originalItem: any) => {
      if (originalItem?._inputId !== null) {
        return;
      }
      setRandomMatrixAnswers(
        update(randomMatrixAnswers, {
          [index]: {
            _inputId: {
              $set: item._id,
            },
          },
        })
      );
    },
    [randomMatrixAnswers]
  );

  const handleDrop = React.useCallback(
    (index: number, item: any, originalItem: any) => {
      if (originalItem?._inputId !== null) {
        return;
      }
      setMatrixSortAnswers(
        update(matrixSortAnswers, {
          [index]: {
            _inputId: {
              $set: item._id,
            },
          },
        })
      );
    },
    [matrixSortAnswers]
  );

  const getMatrixUserInput = (inputId) => {
    const item = matrixSortAnswers.find((ans) => ans._id === inputId);
    return item._sortString;
  };

  const getRandomMatrixUserInput = (inputId) => {
    const item = randomMatrixAnswers.find((ans) => ans._id === inputId);
    return item._id % 2 === 0 ? item._sortString : item._answer;
  };

  const handleRandomCross = (item: any) => {
    const index = randomMatrixAnswers.findIndex((ans) => ans._id === item._id);
    setRandomMatrixAnswers(
      update(randomMatrixAnswers, {
        [index]: {
          _inputId: {
            $set: null,
          },
        },
      })
    );
  };

  const handleCross = (item: any) => {
    const index = matrixSortAnswers.findIndex((ans) => ans._id === item._id);
    setMatrixSortAnswers(
      update(matrixSortAnswers, {
        [index]: {
          _inputId: {
            $set: null,
          },
        },
      })
    );
  };

  switch (type) {
    case "cloze_answer":
      let qst = answerData[0]._answer;
      const answersToReplace = qst.match(/\{.*?\}/g);
      answersToReplace.forEach((item) => {
        let inputLength = item.length;
        // const ansWithoutBraces = item.replace(/[{}]/g, "");
        // const isMathSymbol = symbolTable.filter(
        //   (item) => item.symbol === ansWithoutBraces
        // );

        const hasMultiple = item.match(/\[.*?\]/g);
        if (hasMultiple && hasMultiple.length) {
          inputLength = hasMultiple[0].length;
          hasMultiple.forEach((multi) => {
            if (multi.length > inputLength) {
              inputLength = multi.length;
            }
          });
        }
        inputLength = inputLength - 2;
        // ${
        //   isMathSymbol?.length ? "math-symbol" : "no-math-symbol"
        // }
        const inputTag = `<input type="text" size="${inputLength}" maxLength="${inputLength+2}"  class="default_answer_input multipleInput qc-${qId}"  name="cloze_answer[]" ${
          preview || attemptsDis ? "disabled" : ""
        }/>`;
        qst = qst.replace(item, inputTag);
      });
      let html = ReactHtmlParser(qst);
      return <div className="dynamic_answer">{html}</div>;
    case "single":
      return (
        <div className="">
          {answerData.map((ans: any, index: any) => (
            <div className={"form-check inputRadio qc-" + qId} key={index}>
              <input
                className="form-check-input"
                type="radio"
                name={"exampleRadios-" + index + "-" + qId}
                id={"qc-" + qId + index}
                value={ans._answer && ans._answer.trim()}
                onChange={(e) => handleAnswerChange(e.target.value)}
                checked={compareValues(answer.trim(), ans._answer.trim())}
                disabled={preview || attemptsDis}
              />
              <label className="form-check-label" htmlFor={"qc-" + qId + index}>
                {ReactHtmlParser(ans._answer)}
              </label>
            </div>
          ))}
        </div>
      );
    case "multiple":
      return (
        <div>
          {answerData.map((ans: any, index: any) => (
            <div key={index} className={"form-check inputCheckbox qc-" + qId}>
              <input
                className="form-check-input"
                type="checkbox"
                name={"exampleCheckBox-" + index + "-" + qId}
                value={ans._answer && ans._answer.trim()}
                id={"qc-" + qId + index}
                checked={answer.includes(ans._answer.trim())}
                onChange={handleMultipleAnswer}
                disabled={preview || attemptsDis}
              />
              <label className="form-check-label" htmlFor={"qc-" + qId + index}>
                {ReactHtmlParser(ans._answer)}
              </label>
            </div>
          ))}
        </div>
      );
    case "sort_answer":
      return (
        <DndProvider backend={MultiBackend} options={HTML5toTouch}>
          <div>
            {sortAnswers.map((ans, i) => (
              <SortItem
                key={ans._id + "a"}
                index={i}
                disabled={preview || attemptsDis}
                id={i}
                text={ans._answer}
                moveCard={moveCard}
              />
            ))}
          </div>
        </DndProvider>
      );
    case "matrix_sort_answer":
      if (isRandom) {
        let usedRandomOptionIds = randomMatrixAnswers
          .filter((ans) => ans._inputId !== null)
          .map((res) => res._inputId);

        const randpmOptionsLeft = shuffle(answerData)
          .map((ans) => {
            if (!usedRandomOptionIds.includes(ans._id)) {
              return ans;
            }
          })
          .filter((x) => x);
        const disabled = preview || attemptsDis;
        return (
          <DndProvider backend={MultiBackend} options={HTML5toTouch}>
            <div>
              <div
                style={{ overflow: "hidden", clear: "both" }}
                className="answer_wrapper"
              >
                {randpmOptionsLeft.map((option) => (
                  <RandomMatrixSortItem
                    key={option._id}
                    disabled={disabled}
                    answer={option}
                  />
                ))}
              </div>
              <div>
                {randomMatrixAnswers.map((ans, i) => {
                  const _userInput =
                    ans?._inputId !== null
                      ? getRandomMatrixUserInput(ans?._inputId)
                      : "";
                  return ans._id % 2 === 0 ? (
                    <div key={i} className="matrix_drop_place">
                      <span>{ReactHtmlParser(ans._answer)}</span>
                      <DropArea
                        _userInput={_userInput}
                        disabled={disabled}
                        onDrop={(item) => handleRandomDrop(i, item, ans)}
                        onCross={() => handleRandomCross(ans)}
                      />
                    </div>
                  ) : (
                    <div key={i} className="matrix_drop_place reverse_matrix">
                      <DropArea
                        _userInput={_userInput}
                        disabled={disabled}
                        onDrop={(item) => handleRandomDrop(i, item, ans)}
                        onCross={() => handleRandomCross(ans)}
                      />
                      <span>{ReactHtmlParser(ans._sortString)}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </DndProvider>
        );
      } else {
        let usedOptionIds = matrixSortAnswers
          .filter((ans) => ans._inputId !== null)
          .map((res) => res._inputId);

        const optionsLeft = shuffle(answerData)
          .map((ans) => {
            if (!usedOptionIds.includes(ans._id)) {
              return ans;
            }
          })
          .filter((x) => x);
        const disabled = preview || attemptsDis;
        return (
          <DndProvider backend={MultiBackend} options={HTML5toTouch}>
            <div>
              <div
                style={{ overflow: "hidden", clear: "both" }}
                className="answer_wrapper"
              >
                {optionsLeft.map((option) => (
                  <MatrixSortItem
                    disabled={disabled}
                    key={option._id}
                    answer={option}
                  />
                ))}
              </div>
              <div>
                {matrixSortAnswers.map((ans, i) => {
                  const _userInput =
                    ans?._inputId !== null
                      ? getMatrixUserInput(ans?._inputId)
                      : "";
                  return (
                    <div key={i} className="matrix_drop_place">
                      <span>{ReactHtmlParser(ans._answer)}</span>
                      <DropArea
                        _userInput={_userInput}
                        disabled={disabled}
                        onDrop={(item) => handleDrop(i, item, ans)}
                        onCross={() => handleCross(ans)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </DndProvider>
        );
      }

    default:
      const inputLength = answerData[0]?._answer?.length;
      return (
        <div>
          <input
            name="other_answer[]"
            type="text"
            size={inputLength}
            maxLength={inputLength+2}
            id={"input-text-free-type-" + qId}
            className={"form-control default_answer_input free-type qc-" + qId}
            onChange={(e) => handleAnswerChange(e.target.value)}
            value={answer}
            disabled={preview || attemptsDis}
          />
        </div>
      );
  }
};

export default AnswerType;
